{
  "title": "Communication",
  "subtitle": "Messengers and channels that reach your master agent",
  "whatsapp": {
    "label": "WhatsApp",
    "description": "Incoming messages go straight to your master agent. 1:1 chats only, no media yet.",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "qr_hint": "Open WhatsApp → Linked devices → Scan this code",
    "bridge_unavailable": "Bridge unavailable — install Node.js and run 'npm install' in the bridge directory.",
    "bridge_error": "Bridge error: {{detail}}",
    "states": {
      "disconnected": "Not connected",
      "connecting": "Connecting …",
      "waiting_qr": "Waiting for QR scan",
      "connected": "Connected",
      "error": "Error"
    },
    "filter": {
      "title": "Filter & permissions",
      "intro": "These settings apply to your WhatsApp connection. Owners bypass all filters.",
      "loading": "Loading filter …",
      "private_chats": "Private chats",
      "group_chats": "Group chats",
      "keyword_label": "Activation keyword (empty = always reply)",
      "keyword_placeholder": "e.g. !bot",
      "owner": "Your own numbers (owner bypass)",
      "owner_hint": "Owners see everything, even without keyword/whitelist.",
      "allowed": "Whitelist (empty = allow all)",
      "allowed_hint": "If set: only these numbers may write.",
      "blocked": "Blacklist",
      "blocked_hint": "These numbers are always ignored.",
      "save": "Save",
      "saved": "Saved",
      "no_voices": "No voices loaded from mmx-CLI"
    }
  },
  "discord": {
    "label": "Discord",
    "description": "DMs and @mentions go straight to your master agent.",
    "unavailable": "Discord unavailable.",
    "connect": "Connect",
    "disconnect": "Disconnect",
    "states": {
      "disconnected": "Not connected",
      "connecting": "Connecting …",
      "waiting_qr": "Connecting …",
      "connected": "Connected",
      "error": "Error"
    },
    "filter": {
      "title": "Filter & settings",
      "intro": "Token, filters and behavior for your Discord bot.",
      "loading": "Loading settings …",
      "token_label": "Bot token",
      "token_placeholder": "Paste Discord bot token …",
      "token_hint": "Discord Developer Portal → Bot → Token. 'Message Content Intent' must be enabled.",
      "setup_toggle": "How to set up the bot",
      "setup_step1_title": "1. Create a bot & get the token",
      "setup_step1_body": "Open the Discord Developer Portal → «New Application» → «Bot» on the left → «Reset Token» → copy the token and paste it above.",
      "setup_step2_title": "2. Enable Message Content Intent (important!)",
      "setup_step2_body": "In the Bot tab under «Privileged Gateway Intents», enable «Message Content Intent» and save. Without it the bot won't connect.",
      "setup_step3_title": "3. Invite the bot to your server",
      "setup_step3_body": "OAuth2 → URL Generator → select scope «bot» → permissions «View Channels», «Send Messages», «Read Message History» → open the generated URL → pick your server → authorize.",
      "setup_step4_title": "4. Connect & test",
      "setup_step4_body": "Click «Connect» above. Then DM the bot or @mention it in a channel — it only replies to DMs and @mentions.",
      "setup_portal_link": "Open Discord Developer Portal",
      "dm_enabled": "Receive DMs",
      "mention_enabled": "Receive @mentions",
      "keyword_label": "Activation keyword (empty = always reply)",
      "keyword_placeholder": "e.g. !bot",
      "owner_users": "Owner (your Discord user IDs)",
      "owner_users_hint": "Messages from these IDs are trusted (like you) and bypass the allowlist. Without an entry the bot treats you as an unknown contact too. In server channels every user has a separate conversation with the bot.",
      "allowed_users": "User ID whitelist (empty = allow all)",
      "allowed_users_hint": "If set: only these Discord user IDs may write.",
      "blocked_users": "User ID blacklist",
      "blocked_users_hint": "These user IDs are always ignored.",
      "allowed_channels": "Channel ID whitelist (empty = all)",
      "allowed_channels_hint": "If set: only answer @mentions in these channels. Does not apply to the agent tools (see below).",
      "voice_label": "Reply as voice message",
      "save": "Save",
      "saved": "Saved"
    },
    "tools": {
      "label": "Channels for agent tools",
      "hint": "Agents may only read and write here with the Discord tools (posts inside a forum are included). Nothing selected = no access. Enable the tools per agent under «Tools».",
      "reload": "Reload",
      "not_connected": "Bot not connected — connect above first, then the channels appear here.",
      "no_channels": "The bot can't see any text or forum channels. Has it been invited to the server?",
      "forum": "Forum",
      "read_only": "read only",
      "unreachable": "unreachable",
      "none_selected": "No channel allowed — agents have no Discord access.",
      "count_one": "{{count}} channel allowed — don't forget to save.",
      "count_other": "{{count}} channels allowed — don't forget to save.",
      "moderate": "Moderate",
      "moderate_hint": "Allow moderation tools: set tags, close/lock/pin posts, pin/delete messages, manage forum tags. Deleting always needs confirmation.",
      "moderated_count_one": "{{count}} of them with moderation.",
      "moderated_count_other": "{{count}} of them with moderation."
    },
    "admin": {
      "label": "Manage server",
      "hint": "Management tools for this server: categories, channels, forums, channel permissions, invites, roles, nicknames, timeout, kick, ban. Administrator and “Manage Server” are never granted; the server owner, the bot and owner IDs are protected. Deleting, kick, ban and permissions ask you first.",
      "no_rights": "The bot has no management rights on this server (Administrator or Manage Channels + Manage Roles).",
      "count_one": "{{count}} server with management.",
      "count_other": "{{count}} servers with management."
    }
  }
}
